import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/cost-mb.png")